import React from "react";
import HeroBanner from "../Components/HeroBanner/index";
import Steps from '../Components/Steps/index';
import GrowBussines from "../Components/GrowYourBussiness/index";
import FouurStepFlow from "../Components/FourStepFlow/fourstepflow";
import IntegrationSection from "../Components/IntegrationSection/integration";
import AdvanceEstimator from "../Components/AdvanceEstimator/AdvanceEstimator"
import FAQCTA from "../Components/FAQCTA/faqwithcta"
import TrustedBy from "../Components/TrustedBy/index";
import CashFlow from '../Components/CashFlow/index';
import GoodNews from '../Components/GoodNews/index';
import ClaimPayment from '../Components/ClaimPayment/index';
import CompanyAwards from '../Components/CompanyAwards/index';
import Achievement from '../Components/Achivement/index';
import ImageText from '../Components/ImageWIthText/index';
import ConventionalFinance from '../Components/ConventionalFinance/index';
import MultiStep from '../Components/MultiStep/index';
import Slider from '../Components/SliderSection/index';
import FAQ from '../Components/FAQ/index';
import Advantages from '../Components/Advantages/index';


const HowItWorks = () => {
        return (
                <>
                        <HeroBanner />
                        <FouurStepFlow />
                        {/* <IntegrationSection /> */}
                        <AdvanceEstimator />
                        {/* <FAQCTA /> */}
                        {/* <Steps />
                        <GrowBussines /> */}
                        {/* <TrustedBy /> */}
                        {/* <CashFlow /> */}
                        {/* <GoodNews /> */}
                        {/* <ClaimPayment /> */}
                        {/* <Achievement /> */}
                        {/* <CompanyAwards /> */}
                        {/* <Slider /> */}
                        {/* <ConventionalFinance /> */}
                        {/* <MultiStep /> */}
                        {/* <Advantages /> */}
                        {/* <ImageText /> */}
                        {/* <FAQ /> */}
                </>
        );
}

export default HowItWorks;